import HeaderBg from "./assests/HeaderBg.svg";

const Header = () => (
  <div
    className="relative w-screen overflow-x-hidden"
    style={{
      minHeight: "416px",
      background: `url(${HeaderBg}) center/cover no-repeat`
    }}
  >
    <div
      className="relative text-left z-10 flex flex-col justify-center items-start pl-[10px] md:p-[60px] md:pl-[40px] lg:pl-[160px] 2xl:pl-[370px]"
      style={{ width:'100%', height:'auto' }}
    >
      <div
        className="text-blue-600 text-lg font-medium mb-3 ml-2 mt-12"
        style={{fontFamily: 'Inter, sans-serif', fontWeight: 500}}
      >
        Human-like conversations
      </div>
      <h1
        className="font-bold md:text-[60px] text-[36px] leading-[80px] text-black mb-6"
        style={{ fontFamily: "Manrope, sans-serif" }}
      >
        Select your use case
      </h1>
     <div className="max-w-2xl mb-1">
  <p className="text-gray-800 font-inter md:text-xl text-[14px]"
    style={{fontFamily: 'Inter, sans-serif'}}
  >

    Experience our AI agents for enterprise use cases.
  </p>
  </div>
  <div className="max-w-2xl">
  <p className="text-gray-800 md:text-xl text-[14px] font-inter"
    style={{fontFamily: 'Inter, sans-serif'}}
  >
    Feel free to try them out yourself.
  </p>
</div>
    </div>
  </div>
);

export default Header;
